import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { rolesObject } from 'src/app/services/roles-object';

@Component({
  selector: 'app-roles-generate',
  templateUrl: './roles-generate.component.html',
  styleUrls: ['./roles-generate.component.css']
})
export class RolesGenerateComponent implements OnInit {

  rolesObject: any = rolesObject

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService
  ) { }

  ngOnInit(): void {
    console.log('rolesObject: ', this.rolesObject)
  }

  singleRole: any = [];

  viewRole(role: any) {
    this.singleRole = [role];
  }

  addRole() {
    for (let role of this.rolesObject) {
      let body = {
        "version": role.version || 0,
        "isActive": role.isActive !== undefined ? role.isActive : true,
        "description": role.description || "string",
        "roleName": role.roleName,
        "level": role.level || 0,
        "screenGroupList": role.screenGroupList,
        "cid": sessionStorage.getItem('cid') || 0
      };

      role.isSubmitted = false;
      role.isError = false;

      this.generic_service.addRole(body).subscribe(
        (response: any) => {
          console.log(response.response);
          role.isSubmitted = true;
        },
        (error: any) => {
          console.log(error);
          role.isError = true;
        }
      );
    }
  }
}
